module.exports = __webpack_public_path__ + "static/media/goblin_chief_circle.ec3feb3a.svg";